import { render } from "./TopicEditor.vue?vue&type=template&id=4324ad62&scoped=true"
import script from "./TopicEditor.vue?vue&type=script&lang=js"
export * from "./TopicEditor.vue?vue&type=script&lang=js"

import "./TopicEditor.vue?vue&type=style&index=0&id=4324ad62&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4324ad62"

export default script